const initialState = {
  userLevelMobileNoGetting: "",
  userData: [],
  storeMaterSubschemeName: {},
  moe_unsubscribe: false,
}

const userLevelMobileReducer = (state = initialState, { type, payload }) => {
   
   
    switch (type) {
      case "user_Level_Mobile":
        return {
          ...state,
          userLevelMobileNoGetting: payload,
        }

      case "FETCHUSERDATA":
        return {
          ...state,
          userData: payload,
        }
      case "STOREMASTERSUBSCHEMENAME":
        return {
          ...state,
          storeMaterSubschemeName: payload,
        }
      case "MOU_UNSUBSCRIBE":
        return {
          ...state,
          moe_unsubscribe: payload,
        }

      default:
        return state
    }
  
};

export default userLevelMobileReducer;
